import { BiEventType } from '../../biLogger';
import { getDeviationUrl, getDeviationResourceType, } from '../../DeviationViews/_helpers';
function getBiDataForDeviationLink(deviation) {
    var biData = {
        evid: BiEventType.THUMB_CLICK,
        href: getDeviationUrl(deviation),
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
    };
    if (deviation.author) {
        biData.creatorid = deviation.author.useridUuid;
    }
    return biData;
}
export default getBiDataForDeviationLink;
//# sourceMappingURL=getBiDataForDeviationLink.js.map